import { cn } from "~/utils/fontsConfig";

const EventCardSkeleton = ({ className }: { className?: string }) => {
    return (
        <div
            className={cn(
                `
                    relative
                    mx-auto
                    flex
                    w-full
                    animate-pulse
                    flex-col
                    gap-2
                    md:mx-0
                    md:w-auto
                `,
                className,
            )}
        >
            <div>
                <div className="relative h-[214px] rounded-md bg-gray-200"></div>
                <div className="mt-2 flex justify-between">
                    <div className="h-6 w-1/2 rounded-md bg-gray-200"></div>
                    <div className="h-6 w-1/4 rounded-md bg-gray-200"></div>
                </div>
            </div>
            <div className="flex justify-between">
                <div className="flex gap-2">
                    <div className="h-4 w-20 rounded-md bg-gray-200"></div>
                    <div className="h-4 w-20 rounded-md bg-gray-200"></div>
                    <div className="h-4 w-20 rounded-md bg-gray-200"></div>
                </div>
                <div className="flex gap-2">
                    <div className="h-8 w-8 rounded-full bg-gray-200"></div>
                </div>
            </div>
            <div className="mt-2 h-6 w-3/4 rounded-md bg-gray-200"></div>
        </div>
    );
};

export const EventGridSkeleton = () => {
    return (
        <div
            className="mt-4 grid w-full gap-6 md:gap-12 2xl:gap-6"
            style={{
                gridTemplateColumns: `repeat(auto-fit, minmax(280px, 1fr))`,
            }}
        >
            {[1, 2, 3, 4, 5, 6].map((_, index) => (
                <EventCardSkeleton key={index} />
            ))}
        </div>
    );
};

export default EventCardSkeleton;
